/* eslint-disable max-len */
// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import { Text, Pane, Flex, Button, PortalOverlay, Toast } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
// import I18N from '@leverege/i18n'
// import axios from 'axios'
import classes from './CancelTransferClasses.css';

// const { t } = I18N.ns( 'recovrGeneric.ownershipTransfer' )
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CancelTransferView(props) {
  const {
    onClose,
    parentOutgoingTransfer,
    reloadData,
    organizationId
  } = props;
  const systemId = parentOutgoingTransfer.systemId;
  const parentOutgoingTransferId = parentOutgoingTransfer?.id;
  const parentIncomingTransferId = parentOutgoingTransfer.data?.pairedTransferId;
  const transferredDevicesAlias = parentOutgoingTransfer.data?.transferredDevicesAlias;
  const orgId = organizationId;
  const companyId = parentOutgoingTransfer.data?.company?.id;
  const locationId = parentOutgoingTransfer.data?.location?.id;
  const [loading, setLoading] = useState();

  // const uiName = process.env.UI_NAME
  // const assetIndustryName = t( `assetIndustryName.${uiName}`, 'Asset' )

  const onCancel = evt => {
    try {
      setLoading(true);
      GlobalState.dispatch(async (dispatch, getState, {
        api
      }) => {
        try {
          const state = getState();
          const {
            auth
          } = state;
          const canceledBy = auth?.profile?.name ?? auth?.profile?.username;
          let res;
          if (orgId) {
            res = await api.interface(systemId, 'organization').obj(orgId).grp('companies').obj(companyId).grp('locations').obj(locationId).grp('parentTransfers').obj(parentOutgoingTransferId).srv('ownershipTransfer').post('cancelBulkTransfer', {
              canceledBy,
              parentOutgoingTransferId,
              parentIncomingTransferId,
              deviceAlias: transferredDevicesAlias
            });
          } else {
            res = await api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId).grp('parentTransfers').obj(parentOutgoingTransferId).srv('ownershipTransfer').post('cancelBulkTransfer', {
              canceledBy,
              parentOutgoingTransferId,
              parentIncomingTransferId,
              deviceAlias: transferredDevicesAlias
            });
          }
          if (res.status !== 500) {
            setTimeout(async () => {
              await reloadData();
            }, 2000);
            Toast.success('Transfer canceled');
          } else {
            Toast.error('Error canceling Transfer');
          }
        } catch (error) {
          Toast.error('Error canceling Transfer');
        }
      });
    } catch (error) {
      Toast.error('Error canceling Transfer');
    } finally {
      onClose(evt);
    }
  };
  const iconBackgroundStyle = {
    height: '24px',
    width: '24px',
    borderRadius: '2px',
    backgroundColor: '#F0F6FF',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  };
  const iconStyle = {
    color: '#1646C5',
    position: 'absolute',
    align: 'center'
  };
  const renderDialog = () => /*#__PURE__*/_jsxs(Pane, {
    variant: "editorDialog",
    className: classes.dialog,
    children: [/*#__PURE__*/_jsxs(Flex, {
      className: classes.dialogHeader,
      justify: "space-between",
      children: [/*#__PURE__*/_jsx(Text, {
        style: {
          fontWeight: 'bold'
        },
        icon: /*#__PURE__*/_jsx(Flex, {
          style: {
            ...iconBackgroundStyle
          },
          children: /*#__PURE__*/_jsx("img", {
            style: {
              ...iconStyle
            },
            alt: "Transfer Icon",
            src: "https://storage.googleapis.com/prd-generic-kudelski-ui-assets/Screen%20Icons/screen-transfers-blue.svg"
          })
        }),
        children: "Cancel Transfer"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "closeWindow",
        icon: "fa fa-remove",
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(Pane, {
      style: {
        overflow: 'hidden'
      },
      className: classes.dialogBody,
      children: /*#__PURE__*/_jsx(Text, {
        className: classes.dialogBodyText,
        children: "Canceling this transfer will keep the items in your inventory and stop them from moving to another location. This can\u2019t be undone. To transfer them again, you\u2019ll need to reselect the items and start a new transfer."
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "rowL",
      className: classes.dialogFooter,
      justify: "flex-end",
      children: [/*#__PURE__*/_jsx(Button, {
        variant: "secondary",
        className: classes.cancelButton,
        onClick: onClose,
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "primaryDestructive",
        disabled: loading,
        onClick: onCancel,
        children: " Cancel Transfer "
      })]
    })]
  });
  return /*#__PURE__*/_jsx(PortalOverlay, {
    position: "center",
    show: true,
    closeOnEscape: false,
    closeOnDocumentClick: false,
    children: renderDialog()
  });
}